import { gql } from "@apollo/client";
const getUserRetailerCheckoutOrdersV2 = gql`
  query getUserRetailerCheckoutOrders(
    $statuses: [String!]
    $brandIds: [Float!]
    $page: PageFilter
    $sort: [SortFilter!]
  ) {
    UserRetailerCheckoutOrders(
      statuses: $statuses
      brandIds: $brandIds
      page: $page
      sort: $sort
    ) {
      items {
        checkoutBatchId
        orderId
        retailerOrderId
        userId
        updatedTime
        orderType
        items
        products
        updatedTime
        status
        retailerId
        shippingAddress {
          address1
          address2
          city
          state
          zipCode
          country
          firstName
          lastName
        }
        billingAddress {
          address1
          address2
          city
          state
          zipCode
          country
          firstName
          lastName
        }
        userInteractionRequirement
      }
      total
      maxPages
      nextPage
      hasMore
    }
  }
`;
export {
  getUserRetailerCheckoutOrdersV2
};
//# sourceMappingURL=orderHistoryQueries.js.map
